import React,{useState} from 'react';
import './qualification.css';

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }
  return (
    <section className="qualification section" id='qualification'>
        <h2 className="section__title">Qualification</h2>
        <span className="section__subtitle">My Personal Journey</span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div className={toggleState === 1? "qualification__button qualification__active button--flex" : "qualification__button button--flex"} onClick={() => toggleTab(1)}>
                    <i className="uil uil-graduation-cap qualification__icon"></i> Education
                </div>
                <div className={toggleState === 2? "qualification__button qualification__active button--flex" : "qualification__button button--flex"} onClick={() => toggleTab(2)}>
                    <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                </div>
            </div>
            <div className="qualification__sections">
                <div className={toggleState === 1? "qualification__content qualification__content-active" : "qualification__content"}>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">B.Tech. Information Technology</h3>
                            <span className="qualification__subtitle">LICET, Chennai.<br/><b>Semester 4 - CGPA: 8.9</b></span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> 2021 - Present
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>
                    <div className="qualification__data">
                        <div></div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                        <div>
                            <h3 className="qualification__title">HSC, 12th Standard Board</h3>
                            <span className="qualification__subtitle">K. H. Mat. Boys Hr. Sec. School, Melvisharam.<br/><b>Percentage: 95.84</b></span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> 2019 - 2021
                            </div>
                        </div>
                    </div>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">SSLC, 10th Standard Board</h3>
                            <span className="qualification__subtitle">K. H. Mat. Boys Hr. Sec. School, Melvisharam.<br/><b>Percentage: 95.84</b></span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> 2015 - 2019
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>
                </div>
                <div className={toggleState === 2? "qualification__content qualification__content-active" : "qualification__content"}>
                    <div className="qualification__data">
                        <div>
                            <h3 className="qualification__title">Web Development Intern</h3>
                            <span className="qualification__subtitle">Hackveda Limited</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> July 2023 - Aug 2023 <br/>1 month, Remote
                            </div>
                        </div>
                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                    </div>
                    <div className="qualification__data">
                        <div></div>

                        <div>
                            <span className="qualification__rounder"></span>
                            <span className="qualification__line"></span>
                        </div>
                        <div>
                            <h3 className="qualification__title">Full - Stack Web Development Intern</h3>
                            <span className="qualification__subtitle">Open Weaver India Private Limited</span>
                            <div className="qualification__calendar">
                                <i className="uil uil-calendar-alt"></i> July 2023 - Aug 2023<br/>1 month, Remote
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification